import { render, staticRenderFns } from "./BookButton.vue?vue&type=template&id=675ff172&"
import script from "./BookButton.vue?vue&type=script&lang=js&"
export * from "./BookButton.vue?vue&type=script&lang=js&"
import style0 from "./BookButton.vue?vue&type=style&index=0&id=675ff172&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports